import {AsyncPipe} from '@angular/common'
import {Component, inject} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import {FooterComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import version from '../assets/package.json'
import {HeaderComponent} from './components/header/header.component'
import {ConfigService} from './services/config.service'
import {MatButton} from '@angular/material/button'

@Component({
  selector: 'spb-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    AsyncPipe,
    MatButton
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  public configService: ConfigService = inject(ConfigService)
  public version = version.version
}
